// Copyright (c) 2015, mobileX Neo
// MIT License. See license.txt

import FileUploader from './file_uploader';

neo.provide('neo.ui');
neo.ui.FileUploader = FileUploader;
